<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="60%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="物料凭证号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="belnr" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.belnr" placeholder="物料凭证号" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料凭证项目" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="buzei" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.buzei" placeholder="物料凭证项目" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="ASN单号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="vbeln" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.vbeln" placeholder="ASN单号" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="采购订单号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="ebeln" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.ebeln" placeholder="采购订单号" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="采购订单项目编号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="ebelp" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.ebelp" placeholder="采购订单项目编号" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="matnr" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.matnr" placeholder="物料编码" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="批次" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="charg" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.charg" placeholder="批次" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="描述" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="maktx" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.maktx" placeholder="描述" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="menge" style="margin-bottom: 0;">
                        <ctl-number size="small" v-model="dataForm.menge" :min="0" :max="999" label="描述文字"></ctl-number>
                        <!-- <span v-else>{{dataForm.menge}}</span> -->
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="基本单位" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="meins" style="margin-bottom: 0;">
                        <!-- <span v-if="viewFlag === 'view'">{{getUnitName(dataForm.meins)}}</span> -->
                        <el-select v-model="dataForm.meins"  filterable  placeholder="请选择">
                            <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="移动类型" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="bwart" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.bwart" placeholder="移动类型" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="工厂" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="werks" style="margin-bottom: 0;">
                        <!-- <span v-if="viewFlag === 'view'">{{dataForm.name2}}</span> -->
                        <el-select v-model="dataForm.werks" filterable placeholder="请选择工厂">
                            <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="库存地点" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="lgort" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.lgort" placeholder="库存地点" size="small"></el-input> -->
                        <span>{{dataForm.lgort}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="库存地点名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="lgobe" style="margin-bottom: 0;">
                        <!-- <span v-if="viewFlag === 'view'">{{dataForm.lgobe}}</span> -->
                        <el-select v-model="dataForm.lgobe" filterable placeholder="请选择" @change="handleChange">
                            <el-option v-for="item in storePositionTypeList" :key="item.storeAddress" :label="item.storeName" :value="item.storeAddress">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="项目文本" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="sgtxt" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.sgtxt" placeholder="项目文本" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-row>
        <el-col style="text-align: right">
            <el-button size="small" @click="view.visible = false">
                <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
            </el-button>
            <el-button size="small" type="primary" @click="dataFormSubmit()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getByDeliveryHistoryDetailId,
    createDeliveryHistoryDetail,
    editDeliveryHistoryDetail,
} from "@/controller/sap";
import {
    getUnitList,
    getFactoryList,
    getStorePositionTypeList,
} from "@/controller/systemData"
import CtlNumber from '@/views/common/ctl-number'
export default {
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            unitList: [],
            factoryList:[],
            storePositionTypeList: [],
            dataForm: {
                id: 0,
                historyId: '',
                belnr: '',
                buzei: '',
                vbeln: '',
                ebeln: '',
                ebelp: '',
                matnr: '',
                charg: '',
                maktx: '',
                menge: '',
                meins: '',
                bwart: '',
                werks: '',
                lgort: '',
                sgtxt: '',
                lgobe: '',
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    components: {
        CtlNumber
    },
    methods: {
        // 初始化
        init(id, historyId) {
            console.log(id, historyId)
            this.dataForm.id = id || 0;
            this.dataForm.historyId = historyId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查
                    getByDeliveryHistoryDetailId({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
                this.getUnitList()
                this.getFactoryList()
                this.getStorePositionTypeList()
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let detailParams = {
                        id: this.dataForm.id || undefined,
                        belnr: this.dataForm.belnr,
                        buzei: this.dataForm.buzei,
                        vbeln: this.dataForm.vbeln,
                        ebeln: this.dataForm.ebeln,
                        ebelp: this.dataForm.ebelp,
                        matnr: this.dataForm.matnr,
                        charg: this.dataForm.charg,
                        maktx: this.dataForm.maktx,
                        menge: this.dataForm.menge,
                        meins: this.dataForm.meins,
                        bwart: this.dataForm.bwart,
                        werks: this.dataForm.werks,
                        lgort: this.dataForm.lgort,
                        sgtxt: this.dataForm.sgtxt,
                        lgobe: this.dataForm.lgobe,
                        historyId: this.dataForm.historyId,
                    };
                    if (this.dataForm.id) {
                        editDeliveryHistoryDetail(detailParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshDetailDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createDeliveryHistoryDetail(detailParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshDetailDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        //获取工厂数据
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        //获取单位数据
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        //获取库存地点数据
        getStorePositionTypeList() {
            getStorePositionTypeList({
                storeCode: "",
                storeAddress: "",
                storeName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.storePositionTypeList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        handleChange(val) {
            const type = this.storePositionTypeList.find(type => type.storeAddress === val)
            this.dataForm.lgort = type ? type.storeAddress : ''
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            // return 'text-align: center'
        }
    },
};
</script>
